import { useEffect } from 'react';
import { applyTheme, useThemeStore } from '@/stores/theme-store';

/*
  Mientras la pantalla que lo usa esté montada, la app entera se ve en claro; al salir se
  restaura el tema que el usuario tenía.

  Cómo: el tema de la app es la clase `dark` en <html> (la pone `applyTheme` del store). Acá sólo
  se quita esa clase del documento (no se pinta nada a mano) y se vuelve a aplicar el tema del
  store al desmontar. Es a nivel documento a propósito: los diálogos y popovers se montan en un
  portal fuera de la pantalla y también tienen que salir en claro.

  - La preferencia guardada (`theme-preference`) NO se toca: no se llama a `setTheme`.
  - Si el usuario toca el botón de tema estando acá, el store sí cambia (el botón refleja su
    elección) pero un observador vuelve a quitar `dark` mientras la pantalla siga montada; el
    cambio se ve al salir. Es lo más simple y no deja nada a medias.
  - Con varias pantallas que lo usan a la vez (cambio de ruta), un contador evita restaurar
    antes de tiempo.

  PENDIENTE (futuro, no necesario hoy): el modo noche real del editor del Pricer. Tiene unos
  680 colores fijos (slate-*, bg-white, #hex) que habría que migrar a los tokens del tema; recién
  entonces se podría quitar este hook.
*/
let usos = 0;
let observador: MutationObserver | null = null;

function quitarOscuro() {
  const raiz = document.documentElement;
  if (raiz.classList.contains('dark')) raiz.classList.remove('dark');
}

export function useForzarModoClaro() {
  useEffect(() => {
    usos += 1;
    if (usos === 1) {
      quitarOscuro();
      observador = new MutationObserver(quitarOscuro);
      observador.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
    return () => {
      usos -= 1;
      if (usos === 0) {
        observador?.disconnect();
        observador = null;
        applyTheme(useThemeStore.getState().theme);
      }
    };
  }, []);
}
